var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10918_31341)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.86987 12C6.86987 11.6774 6.99304 11.3548 7.23887 11.1088L14.9785 3.36925C15.4709 2.87692 16.2691 2.87692 16.7613 3.36925C17.2534 3.86139 17.2534 4.65948 16.7613 5.15186L9.91278 12L16.761 18.8481C17.2532 19.3404 17.2532 20.1384 16.761 20.6305C16.2689 21.1231 15.4706 21.1231 14.9783 20.6305L7.23863 12.8911C6.99276 12.645 6.86987 12.3224 6.86987 12Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10918_31341"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(21 3) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.95c6b7eba5595b3d99cd7e7126bb100a.svg";
export { ForwardRef as ReactComponent };